import qs from "qs";
import http from "../http";

function getRootDatasets(payload) {
    return http("GET", `${window.API_URL}/dataset/root?projectId=${payload}`);
}

function createRootDataset(payload) {
    return http("POST", `${window.API_URL}/dataset/root`, payload);
}

function getDatasetsOfTree(payload) {
    return http("GET", `${window.API_URL}/dataset/tree?datasetId=${payload}`);
}

function getDatasetContents(payload) {
    return http(
    "GET",
    `${window.API_URL}/dataset/contents?${qs.stringify(payload)}`
    );
}

function createDataset(payload) {
    return http("POST", `${window.API_URL}/dataset`, payload);
}

function createDatasetRecursively(payload) {
    return http("POST", `${window.API_URL}/datasets`, payload);
}

function createUpload(payload) {
    return http("POST", `${window.API_URL}/dataset/uploading/start`, payload);
}

function createUploadFailure(payload) {
    return http("POST", `${window.API_URL}/dataset/upload/failure`, payload);
}

function stopUpload(payload) {
    return http("POST", `${window.API_URL}/dataset/uploading/stop`, payload);
}

function startUpload(payload) {
    return http("POST", `${window.API_URL}/dataset/upload`, payload);
}

function syncStart(payload) {
    return http("POST", `${window.API_URL}/dataset/sync`, payload);
}

function getUserUploads(payload) {
    return http(
    "GET",
    `${window.API_URL}/dataset/uploading?${qs.stringify(payload)}`
    );
}

function getUploadProgress(payload) {
    return http(
    "GET",
    `${window.API_URL}/dataset/uploading/progress?${qs.stringify(payload)}`
    );
}

function getUploadFailures(payload) {
    return http(
    "GET",
    `${window.API_URL}/dataset/upload/failures?${qs.stringify(payload)}`
    );
}
  
export default {
    getRootDatasets,
    createRootDataset,
    getDatasetsOfTree,
    getDatasetContents,
    createDataset,
    createDatasetRecursively,
    createUpload,
    createUploadFailure,
    stopUpload,
    startUpload,
    syncStart,
    getUserUploads,
    getUploadProgress,
    getUploadFailures,
};